import WaveSurfer from '//www.thewavesociety.com/cdn/shop/t/28/assets/wavesurfer.esm.js?v=71517083031123122521765134808';

function productAudiowave(){
  let ws = null;
let currentAudioUrl = null;
function productAudio(index) {
    const stickyItem = $(".wave-collection__sticky");
    const activeButton = $('#cardPlay-' + index);
    const audiourl = activeButton.attr('data-src');

    // Check if the current audio is already playing
    if (ws && currentAudioUrl === audiourl) {
        if (activeButton.hasClass('is-active') || $(document).find('.wave-collection__sticky .waveColl__product--item').hasClass('play_audio') ) {
            ws.playPause();
            activeButton.removeClass('is-active');
        } else {
            activeButton.addClass('is-active');
            ws.play();
        }
        return;
    }

    // Stop and destroy the previous WaveSurfer instance
    if (ws) {
      if($(document).find('.wave-collection__sticky .waveColl__product--item').hasClass('play_audio')){
        ws.stop();
        ws.destroy();
        removeMarquee(index);
        activeButton.removeClass('is-active');
        $(document).find('.wave-collection__sticky .waveColl__product--item').removeClass('play_audio');
      }
    }

    // Remove active state from all buttons
    $(document).find('.collection--productGrid .card-list_audioPlay').removeClass('is-active');
    $(document).find("#waveColl__sticky--item").html('');

    // Set up the new audio
    const parentInner = activeButton.closest('.product-card-wrapper').html();
    $(document).find("#waveColl__sticky--item").html(parentInner);

    const contentwave = $(document).find('.wave-collection__sticky').find('#wave--audio-' + index).get(0);
    activeButton.addClass('is-active');
    currentAudioUrl = audiourl; // Track the current audio URL

    ws = WaveSurfer.create({
        container: contentwave,
        waveColor: '#48484c',
        progressColor: '#24AAE1',
        height: 45,
        cursorWidth: 0,
        hideScrollbar: false,
        backend: 'MediaElement',
        url: audiourl,
    });

    ws.on('ready', function () {
        ws.play();
         const volume = localStorage.getItem('volumeCollection') ? parseFloat(localStorage.getItem('volumeCollection')) : 1;
         ws.setVolume(volume);
         ws.media.muted = volume === 0;
        
    });

    ws.on('finish', function () {
        activeButton.removeClass('is-active');
        $(document).find('.pausePlay-button ').addClass('is-puase');
        stickyItem.removeClass('is-active');
        $(document).find('.waveColl__product--item .card-wrapper ').removeClass('is-active');
        $(document).find('#card_product-'+index).removeClass('is-active');
        $(document).find('.wave-collection__sticky .waveColl__product--item').removeClass('play_audio');
        ws.stop();
        $('#cardPlay-' + (index + 1)).click();
        //removeMarquee(index);
    });

    ws.on('pause', function () {
        activeButton.removeClass('is-active');
        $(document).find('.pausePlay-button ').addClass('is-puase');
        $(document).find('.waveColl__product--item .card-wrapper ').removeClass('is-active');
        $(document).find('#card_product-'+index).removeClass('is-active');
        $(document).find('.wave-collection__sticky .waveColl__product--item').removeClass('play_audio');
        //removeMarquee(index);
    });

    ws.on('play', function () {
        activeButton.addClass('is-active');
        stickyItem.addClass('is-active');
        $(document).find('.pausePlay-button ').removeClass('is-puase');
        $(document).find('.waveColl__product--item .card-wrapper ').removeClass('is-active');
        $(document).find('#card_product-'+index).addClass('is-active'); 
        //addMarquee(index);
        $(document).find('.wave-collection__sticky .waveColl__product--item').addClass('play_audio');
    });

    ws.on('audioprocess', function () {
        const totalTime = ws.getDuration();
        const currentTime = ws.getCurrentTime();
        const remainingTime = totalTime - currentTime;
        const progress = (currentTime / totalTime) * 100;
        const minutes = Math.floor(remainingTime / 60);
        const seconds = Math.floor(remainingTime % 60);
        const formattedDuration = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

        if (!isNaN(minutes)) {
            $('.wave-collection__sticky #audioDuration-' + index).text(formattedDuration).removeClass('duration_loading');
        }
        $('.wave-collection__sticky #progress-bar-'+index).val(progress).css('background', `linear-gradient(90deg, #24aae1 ${progress}%, #000 ${progress}%)`);

    });

    $(document).find(".wave-collection__sticky").addClass('is-active');

   const savedVolume = localStorage.getItem('volume') ? parseFloat(localStorage.getItem('volume')) : 1;

    // Update volume settings before player initializes
    $('.volbox input[type="range"]').val(savedVolume * 100).css('background', `linear-gradient(90deg, #24aae1 ${savedVolume * 100}%, #fff 1%)`);
    
    if (savedVolume === 0) {
        $('.volumeAudiobutton').addClass('muted');
    } else {
        $('.volumeAudiobutton').removeClass('muted');
    }
}
$(document).on('click', '.collection--productGrid .card-list_audioPlay', function () {
    const dataIndex = $(this).data('index');
    productAudio(dataIndex);

     $('.waveColl__product--item .card__heading a marquee').each(function () {
      var text = $(this).text();             
      $(this).parent().html(text);            
    });
});

function addMarquee(index) {
    var $cardLink = $('.waveColl__product--item  #card_product-' + index + ' .card__heading a');
    var text = $cardLink.text();
    $cardLink.html('<marquee behavior="scroll" direction="right" scrollamount="4">' + text + '</marquee>');
}

// Remove Marquee and restore text
function removeMarquee(index) {
    var $marquee = $('.waveColl__product--item  #card_product-' + index + ' .card__heading a marquee');
    var text = $marquee.text();
    $marquee.parent().html(text);
}
$(document).on('input', '.wave-collection__sticky .card_progressbar input', function (e) {
    const progress = $(this).val(); 
    const seekTo = (progress / 100) * ws.getDuration(); 
    $(this).css('background', `linear-gradient(90deg, #24aae1 ${progress}%, #000 ${progress}%)`);
      ws.seekTo(seekTo / ws.getDuration());
});

 $(document).on("click touch", ".pause-play-next-button button", function() {    
    var dataIndex = parseInt($(this).closest('.pause-play-next-button').attr('data-index'));
    var prevIndex = dataIndex - 1;
    var nextIndex = dataIndex + 1;
    var $cardWrapper = $(document).find('.waveColl__product--item .card-wrapper');

    if ($(this).hasClass("playPrev-button")) {
        if ($('#cardPlay-' + prevIndex).length) {
            $('#cardPlay-' + prevIndex).click();
            $('.pausePlay-button').removeClass('is-puase');
            $cardWrapper.removeClass('is-active');
            $('#card_product-' + prevIndex).addClass('is-active');
            removeMarquee(dataIndex);
        }
    } else if ($(this).hasClass("playNext-button")) {
        if ($('#cardPlay-' + nextIndex).length) {
            $('#cardPlay-' + nextIndex).click();
            $('.pausePlay-button').removeClass('is-puase');
            $cardWrapper.removeClass('is-active');
            $('#card_product-' + nextIndex).addClass('is-active');
            removeMarquee(dataIndex);
        }
    } else {
       if($(document).find('.wave-collection__sticky .waveColl__product--item').hasClass('play_audio')){
        ws.playPause();
      }else {
        productAudio(dataIndex);
        $('.waveColl__product--item .card__heading a marquee').each(function () {
          var text = $(this).text();             
          $(this).parent().html(text);            
        });
      }
    }
});
  
$(document).on('change', '.volbox input', function(e) {
    const volume = $(this).val() / 100; 
    var volumewidth = volume * 100;
      $(this).css('background','linear-gradient(90deg, #24aae1 '+ (volumewidth) +'%, #fff 1%)');
      
      var search_volume = localStorage.getItem('volumeCollection');
      if (search_volume == null) {
      
      } else {
        localStorage.removeItem('volumeCollection');
      }
      localStorage.setItem('volumeCollection', volume);
      
      if (volume === 0) {
          ws.setVolume(0);  // Attempt to set volume to zero
          ws.media.muted = true;  // Explicitly mute the media element
      } else {
          ws.setVolume(volume);  // Set the volume
          ws.media.muted = false;  // Ensure media is not muted
      }
      if (volume == 0){
        $(this).parents('.volumeAudiobutton').addClass('muted'); 
      } else{
        $(this).parents('.volumeAudiobutton').removeClass('muted'); 
      }
});
$(document).on('click', 'span.sticky_ProductClose .icon-close', function (event) {
    event.preventDefault();
    $(".wave-collection__sticky").removeClass('is-active');
    $(document).find('.collection--productGrid .card-list_audioPlay').removeClass('is-active');
    $(document).find('.waveColl__product--item .card-wrapper ').removeClass('is-active');
    if (ws) {
        ws.stop();
        ws.destroy();
        ws = null;
        currentAudioUrl = null;
    }
    var activeAudio = $(this).closest('.wave-collection__sticky').find('.card__content').data('index');
    removeMarquee(activeAudio);
});


}
productAudiowave();


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
                  
          handleobserv();
         
    });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    

  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    
     // productAudiowave();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
     
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();



class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

let currentSearchQuery = "";  

function debounce(func, delay) {
    let timer;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}
 
var input_search = document.querySelector(".waveColl__search .search__input");
if(input_search){
const handleSearchInput = debounce(function (event) {
    var value = this.value.toLowerCase();
    currentSearchQuery = value;  
    const sections = FacetFiltersForm.getSections();
    if (!sections) {
        console.warn("Section ID not found. Check #WaveCollection-top element.");
        return;
    }

    if (value === '' || value === null) {
       const existingFilters = window.location.search.replace("?", ""); 
        currentSearchQuery = "";  
        sections.forEach((section) => {
          var collectionHandle = document.querySelector('#WaveCollection-top').getAttribute('data-handle');
          const collectionHandleurl = `/collections/${collectionHandle}`;
          console.log(collectionHandleurl);
            let url = `${collectionHandleurl}?&section_id=${section.section}`;          
             if (existingFilters) {
                url += `&${existingFilters}`;
            }
            FacetFiltersForm.renderSectionFromFetch(url, event);          
            FacetFiltersForm.renderSectionFromFetch(url, event);
        });
    } else {
        sections.forEach((section) => {
           const existingFilters = window.location.search.replace("?", ""); 
            let url = `/search?q=${encodeURIComponent(value)}&type=product&section_id=${section.section}`;
            if (existingFilters) {
                url += `&${existingFilters}`;
            }
            FacetFiltersForm.renderSectionFromFetch(url, event);
        });
    }
}, 500);

input_search.addEventListener("input", handleSearchInput);
 
FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash = true) {
    let basePath = window.location.pathname;

    if (currentSearchQuery) {
        basePath = "/search";  
        searchParams = `q=${encodeURIComponent(currentSearchQuery)}&type=product&${searchParams}`;
    }

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    sections.forEach((section) => {
        const url = `${basePath}?section_id=${section.section}&${searchParams}`;  
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
            ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
            : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
};
}
